import * as React from "react";
const SvgForbiddenCircle = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.5 5.5L5.50002 18.4998", stroke: "currentColor", style: {
  strokeWidth: "var(--svg-icon-stroke-width)"
}, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 10, stroke: "currentColor", style: {
  strokeWidth: "var(--svg-icon-stroke-width)"
} }));
export default SvgForbiddenCircle;
